<template>
  <div>
    <baseFrame
      :saveText='saveText'
      submitText='提交'
      clearText=''
      @save='save'
      @submit='submit'
      :saveLoading='saveLoading'
      :submitLoading='submitLoading'
      :idText='!payableId?"门店名称 ":"应付单号 "'
      :id='payableId?info.financePayable.code:storeInfo.name'
      :infosArr='infosArr'
    >
      <div slot='content'>
        <lk-card title="应付单信息">
          <lk-form
            :label-width='140'
            label-position="right"
            :model='info.financePayable'
            :rules="ruleValidate"
            ref="financePayable">
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='供应商名称:' prop='supplierId'>
                  <lk-select
                    clearable
                    v-if="!info.financePayable.supplierName"
                    v-model="info.financePayable.supplierId"
                    filterable
                    @on-change="handleChange">
                    <lk-option v-for="(item, index) in suppliers" :key="index" :value="item.supplierId">{{item.supplierName}}</lk-option>
                  </lk-select>
                  <span v-else>{{info.financePayable.supplierName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' offset='2'>
                <lk-form-item label='开票日期:' prop='invoiceDate'>
                  <timeStampDatePicker
                    placeholder='请选择'
                    v-model="info.financePayable.invoiceDate"
                    style="width:100%">
                  </timeStampDatePicker>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='校验类型:'>
                  <lk-select
                    clearable
                    v-if="!info.financePayable.supplierName"
                    v-model="info.financePayable.financePayableCreateType"
                    @on-change="handleFinancePayableTypeChange">
                    <lk-option v-for="(item, index) in financePayableType" :key="index" :value="item.financePayableCreateType">
                      {{item.financePayableTypeName}}
                    </lk-option>
                  </lk-select>
                  <span v-else>  {{financePayableType[tempFinancePayableCreateType - 1].financePayableTypeName}} </span>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' offset='2'>
                <lk-form-item label='发票编码:' offset='2' prop='invoiceCode'>
                  <lk-input
                    clearable
                    placeholder='请输入'
                    v-model="info.financePayable.invoiceCode"
                    :maxlength='100'>
                  </lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span='10'>
                <lk-form-item label='应付明细:'>
                  <lk-button
                    type='primary'
                    @click="handleShowGetGoods"
                    :disabled='!info.financePayable.supplierId'>新增
                  </lk-button>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter="16">
              <lk-col span="22">
                <lk-form-item>
                  <div class="payableGoods">
                    <lk-table border :columns="columns1" :data="goodsList" class="plan-table cancelTableShadow"></lk-table>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='发票总金额:' prop='invoiceAmount'>
                  <lk-input
                    clearable
                    :maxlength='info.financePayable.invoiceAmount < 0 ? 11 : 10'
                    placeholder='请输入'
                    number
                    v-model="info.financePayable.invoiceAmount">
                  </lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' offset='2' >
                <lk-form-item label='总金额:' v-if="tempFinancePayableCreateType !== 2">
                  <span>{{amount.totalPrice}}</span>
                </lk-form-item>
                <lk-form-item label='待抵消总金额:' v-else>
                  <span>{{amount.totalSetOffAmount}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='发票不含税金额:' prop='invoiceAmountWithoutTax'>
                  <lk-input
                    clearable
                    :maxlength='info.financePayable.invoiceAmountWithoutTax < 0 ? 11 : 10'
                    :on-change="handleInvoiceAmountWithoutTaxChange()"
                    placeholder='请输入'
                    number
                    v-model="info.financePayable.invoiceAmountWithoutTax">
                  </lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' offset='2'>
                <lk-form-item label='确认不含税总金额:' v-if="tempFinancePayableCreateType !== 2">
                  <span>{{amount.totalPriceAfterTax}}</span>
                </lk-form-item>
                <lk-form-item label='待抵消不含税总金额:' v-else>
                  <span>{{amount.totalSetOffAmountWithoutTax}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='发票税额:' prop='invoiceTotalTax'>
                  <lk-input
                    clearable
                    number
                    placeholder='请输入'
                    :maxlength='info.financePayable.invoiceTotalTax < 0 ? 11 : 10'
                    :on-change="handleTotalTaxChange()"
                    v-model="info.financePayable.invoiceTotalTax">
                  </lk-input>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' offset='2'>
                <lk-form-item label='确认总税金:' v-if="tempFinancePayableCreateType !== 2">
                  <span>{{amount.totalTax}}</span>
                </lk-form-item>
                <lk-form-item label='待抵消总税额:' v-else>
                  <span>{{amount.totalSetOffTax}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='不含税金额差额:'>
                  <span :class="{blue: amount.amountWithoutTaxBalance !== strZeroToFixed}">{{amount.amountWithoutTaxBalance}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='10' offset='2'>
                <lk-form-item label='税额差额:'>
                  <span :class="{blue: amount.totalTaxDiff !== strZeroToFixed}">{{amount.totalTaxDiff}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='备注:'>
                  <lk-input
                    clearable
                    placeholder='请输入'
                    v-model="info.financePayable.comment"
                    :maxlength='100'>
                  </lk-input>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </lk-form>
        </lk-card>
        <lk-card
          v-if="showActualBatch"
          title="票折实际批次"
          style="marginTop: 20px;"
        >
         <span slot="extra" class="button-txt">请确认发票票折对应的实际商品和实际批次</span>
           <lk-form
            :label-width='140'
            label-position="right"
          >
            <lk-row :gutter='16'>
              <lk-col span='10'>
                <lk-form-item label='总票折金额(不含税):' >
                  <span>{{totalDiscountAmount}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='6'>
                <lk-form-item label='票折对应商品:' >
                  <lk-button
                    type='primary'
                    @click="bringOutTtotalDiscountAmount"
                  >自动分配</lk-button>
                </lk-form-item>
              </lk-col>
              <lk-col span='10'>
                <lk-form-item label='新增商品:' :label-width='60'>
                  <InputSearch
                    @selected='addGoods'
                    :loading='goodsloading'
                    @getData='handleInputSearch'
                    :selectedList='goodsForm'
                    :data='goodsData'
                    style="width:280px"
                    :columns='goodsColumns'
                    placeHolder='请输入商保编码、通用名、商品名来添加商品'
                  >
                  </InputSearch>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col >
                <lk-form-item label='' >
                  <lk-table
                    :data='actualBatchInfo'
                    :columns='actualBatchColumns'
                    border
                  ></lk-table>
                </lk-form-item>
              </lk-col>
            </lk-row>
           </lk-form>
        </lk-card>
      </div>
    </baseFrame>
    <lk-modal v-model="showGoods" title="应付明细" width='850'>
      <lk-tabs type="card" v-model="goodsTabType" @on-click="handleGoodsTypeClick">
        <lk-tab-pane label="验收明细" name="inspection">
          <div class="modelContent">
            <div class="params">
              <lk-form
                :label-width='75'
                label-position="right">
                <lk-row :gutter='16'>
                  <lk-col span='8'>
                    <lk-form-item label='商品名称:'>
                      <lk-input clearable :maxlength='100' placeholder='请输入' v-model.trim="inspectionQuery.approvedDrugName"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='验收时间:'>
                      <timeStampDatePicker clearable transfer placeholder='请输入' v-model="inspectionQuery.inspectionTime"></timeStampDatePicker>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='验收单号:'>
                      <lk-select
                        class="item"
                        placeholder="请选择"
                        multiple
                        :transfer="true"
                        clearable
                        v-model.trim='inspectionQuery.inspectionCodeList'>
                        <lk-option v-for="(item, index) in inspectionCodeList" :key="index" :value="item">{{item}}</lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='税率:'>
                      <lk-select class="item" clearable v-model.trim='inspectionQuery.inputTaxRate' placeholder="请选择">
                        <lk-option v-for="item in taxRateList" :key="item.value" :value="item.value">
                          {{item.name}}
                        </lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-button type='primary' class="mr8" @click="handleSearch">查询</lk-button>
                    <lk-button @click="handleRestQuery">重置</lk-button>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='8'>
                    <lk-checkbox class="mb8" v-model="inspectionQuery.selectAllResult" @on-change='handleSelectAllResult'> 选择搜索结果内所有验收明细</lk-checkbox>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
            <div class="table mb16">
              <loadingSpin v-show="modalLoading"></loadingSpin>
              <lk-table
                border
                :columns='inspectionColumns'
                :data='inspectionGoodsList'
                @on-select="handleTempSelect"
                @on-select-cancel="handleTempCancel"
                @on-select-all="handleSelectAll"
                @on-select-all-cancel="handleSelectAllCancel">
              </lk-table>
            </div>
            <div style="text-align:right">
              <lk-page
                :total="inspectionPage.count"
                :current="inspectionPage.page"
                size="small"
                show-sizer
                show-elevator
                transfer
                @on-change="handleGoodsPage"
                @on-page-size-change="handleGoodsSize">
              </lk-page>
            </div>
          </div>
        </lk-tab-pane>
        <lk-tab-pane label="退货明细" name="refund">
          <div class="modelContent">
            <div class="params">
              <lk-form
                :label-width='75'
                label-position="right">
                <lk-row :gutter='16'>
                  <lk-col span='8'>
                    <lk-form-item label='商品名称:'>
                      <lk-input clearable :maxlength='100' placeholder='请输入' v-model.trim="refundQuery.approvedName"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='退货时间:'>
                      <timeStampDatePicker clearable transfer placeholder='请输入' v-model="refundQuery.refundTime"></timeStampDatePicker>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='退货单号:'>
                      <lk-select
                        class="item"
                        placeholder="请选择"
                        multiple
                        :transfer="true"
                        clearable
                        v-model.trim='refundQuery.refundCodeList'>
                        <lk-option v-for="(item, index) in refundCodeList" :key="index" :value="item">{{item}}</lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='税率:'>
                      <lk-select class="item" clearable v-model.trim='refundQuery.inputTaxRate' placeholder="请选择">
                        <lk-option v-for="item in taxRateList" :key="item.value" :value="item.value">
                          {{item.name}}
                        </lk-option>
                      </lk-select>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-button type='primary' class="mr8" @click="handleSearch">查询</lk-button>
                    <lk-button @click="handleRestQuery">重置</lk-button>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='8'>
                    <lk-checkbox class="mb8" v-model="refundQuery.selectAllResult" @on-change='handleSelectAllResult'> 选择搜索结果内所有退货明细</lk-checkbox>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
            <div class="table mb16">
              <loadingSpin v-show="modalLoading"></loadingSpin>
              <lk-table
                border
                :columns='refundColumns'
                :data='refundGoodsList'
                @on-select="handleTempSelect"
                @on-select-cancel="handleTempCancel"
                @on-select-all="handleSelectAll"
                @on-select-all-cancel="handleSelectAllCancel">
              </lk-table>
            </div>
            <div style="text-align:right">
              <lk-page
                :total="refundPage.count"
                :current="refundPage.page"
                size="small"
                show-sizer
                show-elevator
                transfer
                @on-change="handleGoodsPage"
                @on-page-size-change="handleGoodsSize">
              </lk-page>
            </div>
          </div>
        </lk-tab-pane>
        <lk-tab-pane label="召回单" name="recall">
          <div class="modelContent">
            <div class="params">
              <lk-form
                :label-width='75'
                label-position="right">
                <lk-row :gutter='16'>
                  <lk-col span='8'>
                    <lk-form-item label='商品名称:'>
                      <lk-input clearable :maxlength='100' placeholder='请输入' v-model.trim="recallQuery.nameMix"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='召回单号:'>
                      <lk-input clearable :maxlength='100' placeholder='请输入' v-model.trim="recallQuery.recallPlanCode"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='召回机构:'>
                      <lk-input clearable :maxlength='100' placeholder='请输入' v-model.trim="recallQuery.org"></lk-input>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-form-item label='召回时间:'>
                      <timeStampDatePicker clearable transfer placeholder='请输入' v-model="recallQuery.recallTime" type='daterange'></timeStampDatePicker>
                    </lk-form-item>
                  </lk-col>
                  <lk-col span='8'>
                    <lk-button type='primary' class="mr8" @click="handleSearch">查询</lk-button>
                    <lk-button @click="handleRestQuery">重置</lk-button>
                  </lk-col>
                </lk-row>
                <lk-row :gutter='16'>
                  <lk-col span='8'>
                    <lk-checkbox class="mb8" v-model="recallQuery.selectAllResult" @on-change='handleSelectAllResult'> 选择搜索结果内所有召回单</lk-checkbox>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
            <div class="table mb16">
              <loadingSpin v-show="modalLoading"></loadingSpin>
              <lk-table
                border
                :columns='recallColumns'
                :data='recallGoodsList'
                @on-select="handleTempSelect"
                @on-select-cancel="handleTempCancel"
                @on-select-all="handleSelectAll"
                @on-select-all-cancel="handleSelectAllCancel">
              </lk-table>
            </div>
            <div style="text-align:right">
              <lk-page
                :total="recallPage.count"
                :current="recallPage.page"
                size="small"
                show-sizer
                show-elevator
                transfer
                @on-change="handleGoodsPage"
                @on-page-size-change="handleGoodsSize">
              </lk-page>
            </div>
          </div>
        </lk-tab-pane>
      </lk-tabs>
      <div slot="footer">
        <span class="mr8">已选：{{tempGoods.length}}项</span>
        <lk-button @click="showGoods=false">取消</lk-button>
        <lk-button @click="confirmGoods" type='primary'>确定</lk-button>
      </div>
    </lk-modal>
    <lk-modal
      v-model='appointActualBatchModal'
      title="修改批次"
      width='850'
    >
      <lk-form
        :label-width='80'
        label-position="right">
        <lk-row :gutter='16'>
          <lk-col span='8'>
            <lk-form-item label='批次号:'>
              <lk-input
                v-model="appointBatchQuery.goodsBatchSeq"
              ></lk-input>
            </lk-form-item>
          </lk-col>
          <lk-col span='8'>
            <lk-form-item label='入库时间:'>
              <timeStampDatePicker
                type='daterange'
                placeholder='请选择'
                v-model="appointBatchQuery.time"
                class="item"
              ></timeStampDatePicker>
            </lk-form-item>
          </lk-col>
          <lk-col span='8'>
            <lk-button
              type='primary'
              @click="handlerAppointActualBatch"
            >查询</lk-button>
          </lk-col>
        </lk-row>
        <lk-row :gutter='16'>
          <div class="editBatch">
            <loadingSpin v-show="modalLoading"></loadingSpin>
            <lk-table
              border
              :data='appointBatchData'
              :columns='appointBatchColumns'
              @on-select="handleAppointTempSelect"
              @on-select-cancel="handleAppointTempSelect"
            ></lk-table>
          </div>
          <div style="text-align:right">
            <lk-page
              :total="appointBatchPage.count"
              :current="appointBatchPage.page"
              size="small"
              show-sizer
              show-elevator
              transfer
              @on-change="handleAppointGoodsPage"
              @on-page-size-change="handleAppointGoodsSize">
            </lk-page>
          </div>
        </lk-row>
      </lk-form>
        <div slot="footer">
        <span class="mr8">已选：{{tempAppointBatchData.length}}项</span>
        <lk-button @click="appointActualBatchModal=false">取消</lk-button>
        <lk-button @click="confirmAppointBatch" type='primary'>确定</lk-button>
      </div>
    </lk-modal>

    <DTPModal
      v-model="changeSupplier"
      content='一旦更改供应商名称，将清空已添加的付款明细，是否继续？'
      @confirm='goodsList=[];changeSupplier=false'
      @handleCancel='info.financePayable.supplierId=tempSupplier;changeSupplier=false'
    ></DTPModal>
    <DTPModal
      v-model="checkDiffTax"
      cancel-text="调整"
      content='实际成本与入库成本存在偏差，将生成成本变更单，是否生成？'
      @confirm='checkDiffTaxConfirm'
      @handleCancel='checkDiffTaxCancel'
    ></DTPModal>
    <DTPModal
      v-model="changeFinancePayableType"
      content='切换校验类型将清空已编辑内容，是否确认？'
      @confirm='changeFinancePayableTypeConfirm'
      @handleCancel='changeFinancePayableTypeCancel'
    ></DTPModal>
    <DTPModal
      v-model="automaticModel"
      content='自动分配商品将重置当前票折对应商品内容'
      @confirm='changeAutomaticModelConfirm'
      @handleCancel='automaticModel=false'
    ></DTPModal>
  </div>
</template>
<script>
import _ from 'lodash';
import InputSearch from '@/components/InputSearch.vue';
import goods from '@/services/goods';
import utils from '../../libs/utils';
import baseFrame from '../../components/frame/BaseFrame.vue';
import DTPModal from '../../components/DTPModal.vue';
import finance from '../../services/finance';
import expandRow from './payableExpandRow';
import loadingSpin from '../../components/LoadingSpan';
import DtpInputNumber from '../../components/DtpInputNumber';

export default {
  name: 'payableInfo',
  components: {
    baseFrame,
    DTPModal,
    loadingSpin,
    InputSearch,
  },
  computed: {
    totalDiscountAmount() { // 总票折金额(不含税)
      const amount = this.goodsList.reduce((pre, current) => utils.formatNum(pre + Number(current.amountWithoutTaxBalance * -1), 10), 0);
      return amount;
    },
    taxRateList() {
      return this.$store.state.publicParams.taxRateList;
    },
    storeInfo() {
      return this.$store.state.storeInfo;
    },
    selectedIds() {
      const result = [];
      this.goodsList.forEach((item) => {
        result.push(item.payableInfoKey);
      });
      return result;
    },
    selectedTempGoodsIds() { // 临时选中的明细
      const result = [];
      this.tempGoods.forEach((item) => {
        result.push(item.payableInfoKey);
      });
      return result;
    },
    amount() {
      const result = {
        totalPrice: 0, // 总金额
        totalPriceAfterTax: 0, // 确认不含税金额
        totalTax: 0, // 确认总税金
        amountWithoutTaxBalance: 0, // 不含税金额差额
        totalTaxDiff: 0, // 税差额 = 发票税额 - 确认总税金
        checkTax: false,
        checkDiffTax: false,
        // 票折录入
        totalSetOffAmount: 0, // 待抵消总金额
        totalSetOffAmountWithoutTax: 0, // 待抵消不含税总金额
        totalSetOffTax: 0, // 待抵消总税额
        totalSetOffTaxDiff: 0, // 税额差额
      };
      if (this.goodsList.length) {
        const firstTax = this.goodsList[0].realInputTaxRate;
        this.setInspectionSourceIdList(); // 清空
        this.goodsList.forEach((item) => {
          this.getTaxResult(item);
          if (item.referType === 1) { // 验收明细
            this.setInspectionSourceIdList(item.sourceId);
          }
          result.totalPrice += Number(item.realTotalPriceBeforeTax); // 总金额
          result.totalPriceAfterTax += Number(item.realTotalPriceAfterTax);
          result.totalTax += Number(item.realTotalTax);
          // 票折录入
          result.totalSetOffAmount += Number(item.setOffAmount);
          result.totalSetOffAmountWithoutTax += Number((item.setOffAmount / (1 + item.realInputTaxRate / 100)));
          result.totalSetOffTax += Number(item.realTotalTax);

          if (item.realInputTaxRate !== firstTax) {
            result.checkTax = true;
          }
          // 不含税总差额、不含税差额、税差额】项任意一字段非零时，则给与提示并生成成本变更单
          if (Number(item.amountWithoutTaxBalance) !== 0) {
            result.checkDiffTax = true;
          }
        });
      } else {
        this.setInspectionSourceIdList(); // 清空
      }
      result.totalPrice = result.totalPrice.toFixed(2);
      result.totalPriceAfterTax = result.totalPriceAfterTax.toFixed(2);
      result.totalTax = result.totalTax.toFixed(2);
      result.amountWithoutTaxBalance = result.amountWithoutTaxBalance.toFixed(2);
      result.totalTaxDiff = result.totalTaxDiff.toFixed(2);
      // 票折录入
      result.totalSetOffAmount = result.totalSetOffAmount.toFixed(2);
      result.totalSetOffAmountWithoutTax = result.totalSetOffAmountWithoutTax.toFixed(2);
      result.totalSetOffTax = result.totalSetOffTax.toFixed(2);
      // todo wzy 不应该在computed里修改全局状态
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      // this.info.financePayable.invoiceAmount = Number(result.totalPrice);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      // this.info.financePayable.invoiceAmountWithoutTax = Number(result.totalPriceAfterTax);
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      // this.info.financePayable.invoiceTotalTax = Number(result.totalTax);
      return result;
    },
  },
  data() {
    // 验证发票金额
    const validatorInvoice = (rule, value, callback) => {
      if (/((^\d{1,10}$)|(^\d{1,7}\.\d{2}$)|(^\d{1,8}\.\d$))|((^-\d{1,10}$)|(^-\d{1,7}\.\d{2}$)|(^-\d{1,8}\.\d$))/.test(value)) {
        callback();
      } else {
        return callback(new Error('输入的格式不正确'));
      }
    };
    return {
      // 票折实际批次
      automaticModel: false,
      config: {
        goodsStoreId: '', // 暂存修改批次goodsStoreId
        index: '', // 暂存修改批次的index
      },
      appointBatchPage: {
        count: 0,
        page: 1,
        size: 10,
      },
      appointBatchData: [], // 修改批次table data
      tempAppointBatchData: [], // 暂存指定批次table data
      appointBatchColumns: [
        { type: 'selection', width: 60, fixed: 'left' },
        { title: '验收单号', key: 'inspectionCode', minWidth: 125 },
        { title: '批次号', key: 'goodsBatchSeq', minWidth: 125 },
        {
          title: '入库时间',
          key: 'createTime',
          minWidth: 125,
          render: (h, { row }) => h('span', utils.exchangeTime(row.createTime)),
        },
        { title: '预计总票折', key: 'expectTotalRebateAmount', minWidth: 100 },
        { title: '已录入发票票折', key: 'payableRebateAmount', minWidth: 100 },
        { title: '已录入其他回款', key: 'otherRebateAmount', minWidth: 100 },
        { title: '待回款票折', key: 'diffRebateAmount', minWidth: 100 },
      ],
      appointBatchQuery: { // 修改批次查询params
        goodsBatchSeq: '', // 批次号
        time: [], // 入库时间
      },
      appointActualBatchModal: false, // 指定实际批次modal
      goodsForm: [], // 选择的商品
      goodsData: [], // 展示的商品
      goodsloading: false, // 添加商品时的loading
      goodsColumns: [
        { title: '商品编码', key: 'drugSerialCode', width: '90px' },
        { title: '通用名', key: 'approvedDrugNames', width: '116px' },
        { title: '商品名', key: 'goodsName', width: '116px' },
        { title: '规格', key: 'specifications', width: '80px' },
        { title: '生产厂家', key: 'manufacturer', width: '116px' },
        { title: '包装单位', key: 'drugMiniPackageUnitString', width: '80px' },
      ],
      actualBatchInfo: [], // table data
      tempGoodsList: [], // 暂存tabledata
      showActualBatch: false, // 是否显示票折实际批次
      actualBatchColumns: [
        { title: '商品编码', key: 'drugSerialCode', minWidth: 130 },
        { title: '通用名', key: 'approvedDrugName', minWidth: 130 },
        { title: '商品名', key: 'goodsName', minWidth: 130 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产厂家', key: 'manufacturer', minWidth: 116 },
        { title: '单位', key: 'drugMinimumPackagingUnit', minWidth: 116 },
        {
          title: '本次票折金额',
          key: 'amountWithoutTaxBalance',
          minWidth: 156,
          render: (h, params) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.$set(this.actualBatchInfo[params.index], 'amountWithoutTaxBalance', value);
              },
            },
            props: {
              value: Number(params.row.amountWithoutTaxBalance) || 0,
              disabled: params.row.appointed,
              min: -1000000000,
              ifNeedCheckAllNumber: true,
              maxlength: 15,
              frontDecimal: 7,
              precision: 6,
            },
          }),
        },
        { title: '票折对应批次', key: 'goodsBatchSeq', minWidth: 116 },
        {
          title: '操作',
          key: '',
          fixed: 'right',
          minWidth: 116,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.appointActualBatchModal = true;
                  this.config.goodsStoreId = params.row.goodsStoreId;
                  this.config.index = params.index;
                  this.handlerAppointActualBatch();
                },
              },
            }, '修改批次'),
            h('lk-button', {
              props: {
                type: 'text',
                size: 'small',
              },
              on: {
                click: () => {
                  this.actualBatchInfo.splice(params.index, 1);
                  this.$Message.success('删除成功');
                },
              },
            }, '删除'),
          ]),
        },
      ],
      // 22
      modalLoading: false,
      payableId: null,
      saveText: '',
      checkDiffTax: false,
      tempSupplier: '',
      tempFinancePayableCreateType: null,
      isClear: true,
      infosArr: [],
      changeSupplier: false,
      changeFinancePayableType: false,
      saveLoading: false,
      submitLoading: false,
      suppliers: [], // 供应商列表
      financePayableType: [ // 校验类型列表
        {
          financePayableCreateType: 1,
          financePayableTypeName: '首次发票录入',
        },
        {
          financePayableCreateType: 2,
          financePayableTypeName: '已校验批次成本调整',
        },
      ],

      tempGoods: [],
      inspectionGoodsList: [], // 验收明细商品
      refundGoodsList: [], // 退货明细商品
      recallGoodsList: [], // 召回明细商品
      goodsList: [],
      inspectionSourceIdList: [],
      showGoods: false,
      goodsTabType: 'inspection', // 验收 inspection，退货 refund
      referTypeMap: {
        1: '验收',
        2: '退货',
        3: '召回',
      },
      columns1: [],
      columns: [
        {
          type: 'expand',
          width: 50,
          render: (h, params) => h(expandRow, {
            props: {
              row: params.row,
            },
          }),
        },
        { title: '序号', type: 'index', minWidth: 60 },
        { title: '单号', key: 'referCode', minWidth: 116 },
        {
          title: '单据来源',
          key: 'referType',
          minWidth: 90,
          render: (h, params) => h('span', `${this.referTypeMap[params.row.referType]}`),
        },
        {
          title: '商品通用名称',
          key: 'approvedDrugName',
          minWidth: 130,
          render: (h, params) => h('span', {
            class: {
              noEqual: (params.row.referType === 2 && this.inspectionSourceIdList.length > 0 && !this.inspectionSourceIdList.includes(params.row.sourceId)),
            },
          }, params.row.approvedDrugName),
        },
        {
          title: '原进项税率',
          key: 'taxRate',
          minWidth: 100,
          render: (h, params) => h('span', {
            class: {
              noEqual: params.row.taxRate !== this.goodsList[0].taxRate,
            },

          }, `${params.row.taxRate}%`),
        },
        {
          title: '确认进项税率',
          key: 'realInputTaxRate',
          minWidth: 116,
          render: (h, { row, index }) => {
            const optionArr = this.taxRateList.map(item => h('lk-option', {
              props: {
                value: item.value,
              },
            }, item.name));
            return h('lk-select', {
              props: {
                value: row.realInputTaxRate,
                transfer: true,
                disabled: row.ableToUpdateTaxRate === 2, // 1可以修改确认进项税率 2不可以修改
                label: `${row.realInputTaxRate}%`,
              },
              class: {
                realInputTaxRate: row.taxRate !== row.realInputTaxRate,
              },
              on: {
                'on-change': (value) => {
                  this.goodsList[index].realInputTaxRate = value;
                  row.realInputTaxRate = value;
                  this.getTaxResult(row);
                  this.handlerTotalDiscountAmount();
                },
              },
            },
            optionArr);
          },
        },
        { title: '单价', key: 'priceBeforeTax', minWidth: 116 },
        {
          title: ' 确认进价',
          minWidth: 116,
          render: (h, { row, index }) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.goodsList[index].realPriceWithTax = value;
                row.realPriceWithTax = value;
                this.getTaxResult(row);
                this.handlerTotalDiscountAmount();
              },
            },
            props: {
              value: row.realPriceWithTax,
              // min: 0,
              precision: 6,
            },
          }),
        },
        {
          title: ' 原总金额',
          key: 'originalTotalAmount',
          minWidth: 116,
          render: (h, { row }) => h('span', row.originalTotalAmount),
        },
        {
          title: ' 票折前总金额',
          key: 'amountBeforeDiscount',
          minWidth: 116,
        },
        {
          title: '票折不含税金额',
          minWidth: 136,
          render: (h, { row, index }) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.goodsList[index].discountWithoutTax = value || 0;
                row.discountWithoutTax = value;
                this.getTaxResult(row);
                this.handlerTotalDiscountAmount();
              },
            },
            props: {
              value: row.discountWithoutTax || 0,
              // min: 0,
              precision: 6,
            },
          }),
        },
        {
          title: ' 票折税额',
          minWidth: 116,
          render: (h, { row, index }) => h(DtpInputNumber, {
            on: {
              'on-blur': (value) => {
                this.goodsList[index].discountTax = value || 0;
                row.discountTax = value;
                this.getTaxResult(row);
                this.handlerTotalDiscountAmount();
              },
            },
            props: {
              value: row.discountTax || 0,
              // min: 0,
              precision: 6,
            },
          }),
        },
        {
          title: ' 确认总金额',
          key: 'realTotalPriceBeforeTax',
          minWidth: 116,
          render: (h, { row }) => h('span', {
            class: {
              blue: this.diffInfo(row),
            },
          }, row.realTotalPriceBeforeTax),
        },
        {
          title: ' 待抵消金额',
          key: 'setOffAmount',
          minWidth: 116,
          render: (h, { row }) => h('span', {
            class: {
              blue: this.diffInfo(row),
            },
          }, row.setOffAmount),
        },
        {
          title: '确认不含税单价',
          key: 'realPriceAfterTax',
          minWidth: 136,
          render: (h, { row }) => h('span', {
            class: {
              blue: this.diffInfo(row),
            },
          }, row.realPriceAfterTax),
        },
        {
          title: '确认不含税总金额',
          key: 'realTotalPriceAfterTax',
          minWidth: 144,
          render: (h, { row }) => h('span', {
            class: {
              blue: this.diffInfo(row),
            },
          }, row.realTotalPriceAfterTax),
        },
        {
          title: '确认总税金',
          key: 'realTotalTax',
          minWidth: 116,
          render: (h, { row }) => h('span', {
            class: {
              blue: this.diffInfo(row),
            },
          }, row.realTotalTax),
        },
        {
          title: '不含税总差额',
          key: 'amountWithoutTaxBalance',
          minWidth: 116,
          render: (h, { row }) => h('span', {
            class: {
              blue: this.diffInfo(row),
            },
          }, row.amountWithoutTaxBalance),
        },
        {
          title: '操作',
          fixed: 'right',
          width: 100,
          render: (h, params) => h('div', [
            h('lk-button', {
              props: {
                type: 'text',
              },
              on: {
                click: () => {
                  this.goodsList.splice(params.index, 1);
                  this.$Message.success('删除成功');
                  this.handlerTotalDiscountAmount();
                },
              },
            }, '删除'),
          ]),
        },
      ],
      inspectionColumns: [
        { type: 'selection', width: 60 },
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '单号', key: 'referCode', minWidth: 116 },
        { title: '商品通用名称', key: 'approvedDrugName', minWidth: 130 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '单价', key: 'realPriceWithTax', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '税率', key: 'realInputTaxRateStr', minWidth: 116 },
        { title: '不含税单价', key: 'priceAfterTax', minWidth: 116 },
        { title: '单个税额', key: 'tax', minWidth: 116 },
        { title: '含税总金额', key: 'totalPriceBeforeTax', minWidth: 116 },
        { title: '总税额', key: 'totalTax', minWidth: 116 },
      ],
      refundColumns: [
        { type: 'selection', width: 60 },
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '单号', key: 'referCode', minWidth: 116 },
        { title: '商品通用名称', key: 'approvedDrugName', minWidth: 130 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '单价', key: 'priceBeforeTax', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '确认税率', key: 'realInputTaxRateStr', minWidth: 116 },
        { title: '不含税单价', key: 'priceAfterTax', minWidth: 116 },
        { title: '单个税额', key: 'tax', minWidth: 116 },
        { title: '含税总金额', key: 'totalPriceBeforeTax', minWidth: 116 },
        { title: '总税额', key: 'totalTax', minWidth: 116 },
      ],
      recallColumns: [
        { type: 'selection', width: 60 },
        { title: '序号', type: 'index', minWidth: 116 },
        { title: '召回单号', key: 'referCode', minWidth: 116 },
        { title: '商品通用名称', key: 'approvedDrugName', minWidth: 130 },
        { title: '商品编码', key: 'drugSerialCode', minWidth: 116 },
        { title: '规格', key: 'specification', minWidth: 116 },
        { title: '商品批号', key: 'goodsBatchNumber', minWidth: 116 },
        { title: '生产企业', key: 'manufacturer', minWidth: 116 },
        { title: '召回机构', key: 'recallAgency', minWidth: 116 },
        {
          title: '召回时间',
          key: 'createTime',
          minWidth: 116,
          render: (h, params) => h('span', utils.exchangeTime(params.row.createTime)),
        },
        { title: '单价', key: 'priceBeforeTax', minWidth: 116 },
        { title: '数量', key: 'num', minWidth: 116 },
        { title: '确认税率', key: 'realInputTaxRateStr', minWidth: 116 },
        { title: '不含税单价', key: 'priceAfterTax', minWidth: 116 },
        { title: '单个税额', key: 'tax', minWidth: 116 },
        { title: '含税总金额', key: 'totalPriceBeforeTax', minWidth: 116 },
        { title: '总税额', key: 'totalTax', minWidth: 116 },
      ],
      strZeroToFixed: '0.00',
      tabTypeMap: {
        inspection: 1,
        refund: 2,
        recall: 3,
      },
      inspectionQuery: {
        approvedDrugName: null,
        inspectionTime: null,
        inspectionCodeList: null,
        inputTaxRate: null,
      },
      inspectionPage: {
        count: 0,
        page: 1,
        size: 10,
      },
      inspectionParams: {},
      refundQuery: {
        approvedDrugName: null,
        refundTime: null,
        refundCodeList: null,
        inputTaxRate: null,
      },
      refundPage: {
        count: 0,
        page: 1,
        size: 10,
      },
      refundParams: {},
      recallQuery: {
        recallTime: [],
        recallPlanCode: null,
        nameMix: null,
        startTime: null,
        endTime: null,
        org: null,
      },
      recallPage: {
        count: 0,
        page: 1,
        size: 10,
      },
      recallParams: {},
      info: {
        financePayable: {
          invoiceCode: '',
          invoiceDate: null,
          supplierId: '',
          comment: '',
          invoiceAmount: '',
          invoiceTotalTax: null,
          invoiceAmountWithoutTax: null,
        },
        purchaseMedicineInfoVoList: [],
      },
      ruleValidate: {
        type: [
          {
            required: true, message: '此处为必填项，不能为空', trigger: 'change', type: 'number',
          },
        ],
        supplierId: [
          {
            required: true, message: '此处为必填项，不能为空', trigger: 'change', type: 'number',
          },
        ],
        invoiceAmount: [
          {
            required: true, message: '此处为必填项，不能为空',
          },
          {
            trigger: 'change', type: 'number', message: '此处必输入数字',
          },
          {
            validator: validatorInvoice,
            message: '最多支持2位有效小数',
          },
        ],
        invoiceAmountWithoutTax: [
          {
            required: true, message: '此处为必填项，不能为空',
          },
          {
            trigger: 'change', type: 'number', message: '此处必输入数字',
          },
          {
            validator: validatorInvoice,
            message: '最多支持2位有效小数',
          },
        ],
        invoiceTotalTax: [
          {
            required: true, message: '此处为必填项，不能为空',
          },
          {
            trigger: 'change', type: 'number', message: '此处必输入数字',
          },
          {
            validator: validatorInvoice,
            message: '最多支持2位有效小数',
          },
        ],
        invoiceCode: [
          {
            required: true, message: '请填写发票编码', trigger: 'blur',
          },
        ],
        invoiceDate: [
          {
            required: true, message: '请填写开票日期', trigger: 'blur', type: 'number',
          },
        ],
      },
      inspectionCodeList: [],
      refundCodeList: [],
      // taxRateList: [0, 3, 6, 9, 13],
    };
  },
  watch: {
    tempFinancePayableCreateType: {
      handler(val) {
        this.columns.forEach((item) => {
          if (item.key == 'realTotalPriceAfterTax') {
            item.title = val == 2 ? '待抵消不含税金额' : '确认不含税总金额';
          }
          if (item.key == 'realTotalTax') {
            item.title = val == 2 ? '待抵消总税金' : '确认总税金';
          }
        });
        if (val !== 2) {
          this.columns1 = this.columns.filter(col => col.key !== 'originalTotalAmount' && col.key !== 'setOffAmount');
        } else {
          this.columns1 = this.columns;
        }
      },
      immediate: true,
    },
    amount: {
      handler(val) {
        if (this.tempFinancePayableCreateType === 2) {
          this.info.financePayable.totalSetOffAmount = Number(val.totalSetOffAmount);
          this.info.financePayable.totalSetOffAmountWithoutTax = Number(val.totalSetOffAmountWithoutTax);
          this.info.financePayable.totalSetOffTax = Number(val.totalSetOffTax);
          this.info.financePayable.invoiceAmount = Number(val.totalSetOffAmount);
          this.info.financePayable.invoiceAmountWithoutTax = Number(val.totalSetOffAmountWithoutTax);
        } else {
          this.info.financePayable.invoiceAmountWithoutTax = Number(val.totalPriceAfterTax);
          this.info.financePayable.invoiceAmount = Number(val.totalPrice);
        }
        this.info.financePayable.invoiceTotalTax = Number(val.totalTax);
      },
      deep: true,
    },
  },
  methods: {

    handlerTotalDiscountAmount() {
      const detail = this.goodsList.find(item => Number(item.amountWithoutTaxBalance) !== 0);
      if (detail) {
        this.showActualBatch = true;
      } else {
        this.showActualBatch = false;
        this.actualBatchInfo = [];
      }
    },
    handlerAppointActualBatch() {
      const params = {
        goodsStoreId: this.config.goodsStoreId,
        supplierStoreId: this.info.financePayable.supplierId,
        page: this.appointBatchPage.page,
        size: this.appointBatchPage.size,
        goodsBatchSeq: this.appointBatchQuery.goodsBatchSeq,
      };
      if (this.appointBatchQuery.time[1]) {
        params.startDate = this.appointBatchQuery.time[0];
        params.endDate = this.appointBatchQuery.time[1];
      } else {
        params.endDate = '';
      }
      finance.listBatchReqByGoodStore(params).then((res) => {
        this.appointBatchData = [];
        if (res.data.status === 200) {
          this.appointBatchData = res.data.data.list;
          this.appointBatchPage.count = res.data.data.count;
        }
      });
    },
    confirmAppointBatch() {
      const {
        goodsBatchSeq,
        inspectionDetailId,
      } = this.tempAppointBatchData;
      const batchs = this.actualBatchInfo.map(item => (item.inspectionDetailId || item.sourceId));
      if (batchs.includes(inspectionDetailId)) {
        this.$Message.warning('该批次已选择，请检查');
      } else {
        this.$nextTick(() => {
          this.$set(this.actualBatchInfo[this.config.index], 'goodsBatchSeq', goodsBatchSeq);
          this.actualBatchInfo[this.config.index].inspectionDetailId = inspectionDetailId;
        });
        this.appointActualBatchModal = false;
        this.$Message.success('修改批次成功');
      }
    },
    handleAppointTempSelect(selection, row) {
      this.appointBatchData.forEach((item) => {
        if (item.inventoryId !== row.inventoryId) {
          this.$nextTick(() => {
            this.$set(item, '_checked', false);
          });
        } else {
          this.$set(item, '_checked', true);
        }
      });
      this.tempAppointBatchData = row; // 暂存选择的批次信息
    },
    handleAppointGoodsPage(val) {
      this.appointBatchPage.page = val;
      this.handlerAppointActualBatch();
    },
    handleAppointGoodsSize(val) {
      this.appointBatchPage.size = val;
      this.handlerAppointActualBatch();
    },
    addGoods(val) {
      this.actualBatchInfo.push(val);
    },
    handleInputSearch(val) {
      this.goodsloading = true;
      this.goodsData = [];
      const params = {
        nameMix: val,
      };
      goods.listGoodsStores(params).then((res) => {
        if (res.data.status === 200) {
          if (res.data.data && res.data.data.list) {
            const list = res.data.data.list;
            list.length && list.forEach((item) => {
              const result = item.goodsBaseVO.goodsBase;
              result.approvedDrugName = item.goodsBaseVO.goodsBase.approvedDrugNames;
              result.specification = item.goodsBaseVO.goodsBase.specifications;
              result.drugMinimumPackagingUnit = item.goodsBaseVO.goodsBase.drugMiniPackageUnitString;
              result.goodsStoreId = item.goodsStoreId;
              this.goodsData.push(item.goodsBaseVO.goodsBase);
            });
          }
        } else {
          this.$Message.error(res.data.error);
        }
        this.goodsloading = false;
      }).catch((err) => {
        utils.handleError(err);
        this.goodsloading = false;
      });
    },
    changeAutomaticModelConfirm() {
      this.handlerAmountWithoutTaxBalance();
      this.automaticModel = false;
    },
    bringOutTtotalDiscountAmount() {
      if (this.actualBatchInfo.length) {
        this.automaticModel = true;
      } else {
        this.handlerAmountWithoutTaxBalance();
      }
    },
    handlerAmountWithoutTaxBalance() {
      this.actualBatchInfo = [];
      const list = this.goodsList.filter(item => Number(item.amountWithoutTaxBalance) !== 0);
      list.forEach((item) => {
        const result = utils.deepClone(item);
        result.amountWithoutTaxBalance = Number(item.amountWithoutTaxBalance) * (-1);
        this.actualBatchInfo.push(result);
      });
    },
    setInspectionSourceIdList(value) {
      if (value) {
        this.inspectionSourceIdList.push(value);
      } else {
        this.inspectionSourceIdList = [];
      }
    },
    // 切换应付商品tab
    handleGoodsTypeClick() {
      this[`${this.goodsTabType}Query`] = {};
      this[`${this.goodsTabType}Params`] = utils.deepClone(this[`${this.goodsTabType}Query`]);
      this.getData();
    },
    // 不含税差额 = 发票不含税总金额 - 确认不含税总金额
    handleInvoiceAmountWithoutTaxChange() {
      if (utils.isNumber(this.info.financePayable.invoiceAmountWithoutTax)) {
        if (this.tempFinancePayableCreateType !== 2) {
          this.amount.amountWithoutTaxBalance = (this.info.financePayable.invoiceAmountWithoutTax - this.amount.totalPriceAfterTax).toFixed(2);
        } else {
          this.amount.amountWithoutTaxBalance = (this.info.financePayable.invoiceAmountWithoutTax - this.amount.totalSetOffAmountWithoutTax).toFixed(2);
        }
      } else {
        this.amount.amountWithoutTaxBalance = this.strZeroToFixed;
      }
    },
    // 税额差额 = 发票税额 - 确认总税金
    handleTotalTaxChange() {
      if (utils.isNumber(this.info.financePayable.invoiceTotalTax)) {
        if (this.tempFinancePayableCreateType !== 2) {
          this.amount.totalTaxDiff = (this.info.financePayable.invoiceTotalTax - this.amount.totalTax).toFixed(2);
        } else {
          this.amount.totalTaxDiff = (this.info.financePayable.invoiceTotalTax - this.amount.totalSetOffTax).toFixed(2);
        }
      } else {
        this.amount.totalTaxDiff = this.strZeroToFixed;
      }
    },
    // 计算税率
    getTaxResult(row) {
      // const price = row.priceBeforeTax; // 单价
      const price = row.realPriceWithTax; // 确认进价
      const realInputTaxRate = row.realInputTaxRate / 100;
      const discountWithoutTax = row.discountWithoutTax || 0;
      const discountTax = row.discountTax || 0;
      // 原总金额
      const originalTotalAmount = row.originalTotalAmount || 0;
      // 票折前总金额
      row.amountBeforeDiscount = utils.toFixed2(price * row.num);
      // 确认总金额
      row.realTotalPriceBeforeTax = utils.toFixed2(price * row.num - discountWithoutTax - discountTax);
      // 确定不含税税单价
      row.realPriceAfterTax = utils.toFixed2(price / (1 + realInputTaxRate));
      if (this.tempFinancePayableCreateType === 2) {
        // 待抵消金额
        row.setOffAmount = utils.toFixed2(row.realTotalPriceBeforeTax - originalTotalAmount);
        // 确认不含税总金额
        row.realTotalPriceAfterTax = utils.toFixed2(row.setOffAmount / (1 + realInputTaxRate));
        // 确认总税金
        row.realTotalTax = utils.toFixed2(row.realTotalPriceAfterTax * realInputTaxRate);
        // 不含税总差额
        row.amountWithoutTaxBalance = utils.toFixed2(row.realTotalPriceAfterTax);
      } else {
        // 确认不含税总金额
        row.realTotalPriceAfterTax = utils.toFixed2(row.realTotalPriceBeforeTax / (1 + realInputTaxRate));
        // 确认总税金
        row.realTotalTax = utils.toFixed2(row.realTotalPriceAfterTax * realInputTaxRate);
        // 不含税总差额
        row.amountWithoutTaxBalance = utils.toFixed2(row.realTotalPriceAfterTax - row.totalPriceAfterTax);
      }
      this.$set(this.goodsList, row._index, row);
    },
    checkDiffTaxConfirm() { // 确认成本变更提交
      this.checkDiffTax = false;
      this.doFormAction(2);
    },
    checkDiffTaxCancel() {
      this.checkDiffTax = false;
    },
    changeFinancePayableTypeConfirm() {
      this.goodsList = [];
      this.changeFinancePayableType = false;
      this.tempFinancePayableCreateType = this.info.financePayable.financePayableCreateType;
    },
    changeFinancePayableTypeCancel() {
      this.info.financePayable.financePayableCreateType = this.tempFinancePayableCreateType;
      this.changeFinancePayableType = false;
    },
    handleChange(val) {
      // console.log(val);
      if (!this.isClear) {
        this.changeSupplier = true;
      } else {
        this.tempSupplier = val;
      }
      this.isClear = !val;
    },
    handleFinancePayableTypeChange(val) {
      if (this.goodsList.length > 0) {
        this.changeFinancePayableType = true;
      } else {
        this.tempFinancePayableCreateType = val;
      }
    },
    judgeIShasRefundCodeList(argu) {
      if (argu instanceof Array) {
        let str = '';
        argu.forEach(ele => {
          if (ele.refundCodeList && ele.refundCodeList.length) {
            ele.refundCodeList.forEach(item => {
              str += `${item}<br/>`
            })
          }
        });
        if (str.length) {
          this.$Modal.warning({
            title: '提示',
            content: `<p>所选验收单有未校验发票的退货单${str}请确认是否需要选择<p>`,
            okText: '我知道了',
          })
        }
      } else {
        if (argu.refundCodeList && argu.refundCodeList.length) {
          let str = '';
          argu.refundCodeList.forEach(item => {
            str += `${item}<br/>`
          })
          this.$Modal.warning({
            title: '提示',
            content: `<p>该验收单有未校验发票的退货单${str}请确认是否需要选择<p>`,
            okText: '我知道了',
          })
        }
      }
    },
    changeGoodItem(item) {
      if (!this.selectedIds.includes(item.payableInfoKey)) {
        this.getTaxResult(item);
      }
      return item;
    },
    handleTempSelect(selection, row) {
      this.judgeIShasRefundCodeList(row);
      if (!this.selectedTempGoodsIds.includes(row.payableInfoKey)) {
        this.tempGoods.push(this.changeGoodItem(row));
      }
    },
    handleTempCancel(selection, row) {
      this.tempGoods.forEach((item, index) => {
        if (item.payableInfoKey === row.payableInfoKey) {
          this.tempGoods.splice(index, 1);
        }
      });
      this.inspectionQuery.selectAllResult = false;
    },
    handleSelectAll(selection) {
      this.judgeIShasRefundCodeList(selection);
      selection.forEach((item) => {
        if (!this.selectedTempGoodsIds.includes(item.payableInfoKey)) {
          this.tempGoods.push(this.changeGoodItem(item));
        }
      });
    },
    handleSelectAllCancel() {
      // 全部取消的时候，只能把当前选中的列表置空，但是在一选择的列表中无法区分出来，所以本处采用对当列表进行单个操作
      this[`${this.goodsTabType}GoodsList`].forEach((good) => {
        // 列表中已经存在 查找该项目在tempGoods中的位置并移除
        for (let i = 0, len = this.tempGoods.length; i < len; i++) {
          if (this.tempGoods[i].payableInfoKey === good.payableInfoKey) {
            this.tempGoods.splice(i, 1);
            break;
          }
        }
      });
    },
    checkForm(callback) {
      this.$refs.financePayable.validate((val) => {
        if (!val) {
          this.$Message.error('请填写完整信息');
        } else {
          if (!this.goodsList.length) {
            this.$Message.error('不可创建商品为空的应付单');
            return;
          }
          if (this.amount.checkTax) {
            this.$Message.error('存在确认进项税率不一致的商品，请分开提交。');
            return;
          }
          callback && callback();
        }
      });
    },
    save() {
      const checkout = this.checkoutActualBatch();
      if (!checkout) {
        return;
      }
      this.checkForm(() => {
        this.doFormAction();
      });
    },
    // eslint-disable-next-line func-names
    doFormAction: _.throttle(function (type = 1) { // 1保存 2提交
      this.info.purchaseMedicineInfoVoList = [];
      const temp = utils.deepClone(this.info);
      temp.financePayableInfoList = [];
      this.goodsList.forEach((item) => {
        temp.financePayableInfoList.push({
          goodsStoreId: item.goodsStoreId,
          referDetailId: item.referDetailId,
          realInputTaxRate: item.realInputTaxRate,
          sourceId: item.sourceId,
          referType: item.referType,
          realPriceWithTax: item.realPriceWithTax,
          // 票折录入传参
          amountBeforeDiscount: item.amountBeforeDiscount,
          discountWithoutTax: item.discountWithoutTax || 0,
          discountTax: item.discountTax || 0,
          originalTotalAmount: item.originalTotalAmount || 0,
          setOffAmount: item.setOffAmount || 0,
        });
      });
      temp.rebateInfoList = [];
      if (this.actualBatchInfo.length) {
        this.actualBatchInfo.forEach((item) => {
          temp.rebateInfoList.push({
            inspectionDetailId: item.inspectionDetailId || item.sourceId,
            submitAmount: item.amountWithoutTaxBalance || 0,
          });
        });
      }
      this[type === 1 ? 'saveLoading' : 'submitLoading'] = true;
      let finalFn = finance.addFinancePayable; // 正常保存
      let showMsg = '新建成功';
      if (type === 1) {
        if (this.payableId) { // 修改时保存
          temp.financePayableId = this.payableId;
          finalFn = finance.editFinancePayable;
          showMsg = '修改成功';
        }
      } else {
        finalFn = finance.addAndSubmitFinancePayable; // 正常提交
        if (this.payableId) { // 修改提交
          temp.financePayableId = this.payableId;
          finalFn = finance.submitFinancePayable; //  保存时提交
        }
      }
      finalFn(temp).then((res) => {
        if (res.data.status === 200) {
          this.$Message.success(showMsg);
          setTimeout(() => {
            this.$router.push({ name: 'payable' });
          }, 1000);
        } else {
          this[type === 1 ? 'saveLoading' : 'submitLoading'] = false;
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        this[type === 1 ? 'saveLoading' : 'submitLoading'] = false;
        utils.handleError(err);
      });
    }, 2000),
    submit() {
      const temp = this.info.financePayable;
      if (!(temp.invoiceAmount == ((temp.invoiceAmountWithoutTax) * 1 + (temp.invoiceTotalTax) * 1).toFixed(2))) { // 校验发票总金额是否等于发票不含税金额+发票税额
        this.$Message.error('发票总金额不等于发票不含税金额+发票税额，请检查');
        return;
      }
      const checkout = this.checkoutActualBatch();
      if (!checkout) {
        return;
      }
      this.checkForm(() => {
        // 不含税总差额、不含税差额、税差额】项任意一字段非零时，则给与提示并生成成本变更单
        if (this.amount.checkDiffTax || Number(this.amount.amountWithoutTaxBalance) !== 0 || Number(this.amount.totalTaxDiff) !== 0) {
          this.checkDiffTax = true;
        } else {
          this.doFormAction(2);
        }
      });
    },
    checkoutActualBatch() {
      const amount = this.actualBatchInfo.reduce((pre, current) => utils.formatNum(pre + Number(current.amountWithoutTaxBalance || 0), 10), 0);
      const errArr = [];
      this.actualBatchInfo.forEach((item) => {
        if (!item.goodsBatchSeq) {
          errArr.push(item);
        }
      });
      if (this.totalDiscountAmount === amount && !errArr.length) {
        return true;
      }
      if (this.totalDiscountAmount !== amount) {
        this.$Message.error('票折实际批次明细金额合计不等于总票折金额，请检查');
        return false;
      }
      if (errArr.length) {
        this.$Message.error('存在商品未选择对应批次，请检查后重新提交');
        return false;
      }
    },
    confirmGoods() {
      const exsitIdArr = this.goodsList.map(item => item.referDetailId);
      const goodsList = utils.deepClone(this.tempGoods).map((item) => {
        if (exsitIdArr.includes(item.referDetailId)) {
          const exsitGood = utils.deepClone(this.goodsList.find(good => good.referDetailId === item.referDetailId));
          return exsitGood;
        }
        // item.taxRate = item.realInputTaxRate;
        // item.priceBeforeTax = item.realPriceWithTax;
        return item;
      });

      this.goodsList = [];
      // 分时处理，勾选"选择搜索结果内所有明细"导致数据过多
      this.$store.commit('setLoading', true);
      utils.timeChunk(goodsList, (goods) => {
        this.goodsList.push(goods);
        this.handlerTotalDiscountAmount();
      }, 20, () => {
        this.$store.commit('setLoading', false);
      })();
      this.showGoods = false;
    },
    handleGoodsPage(val) { // type: 对应分页信息的模型
      this[`${this.goodsTabType}Page`].page = val;
      this.getData();
    },
    handleGoodsSize(val) {
      this[`${this.goodsTabType}Page`].size = val;
      this.getData();
    },
    handleSearch() {
      this[`${this.goodsTabType}Page`].page = 1;
      if (this.goodsTabType === 'recall' && this.recallQuery.recallTime) {
        this.recallQuery.startTime = this.recallQuery.recallTime[0] || '';
        this.recallQuery.endTime = this.recallQuery.recallTime[1] || '';
      }
      this[`${this.goodsTabType}Params`] = utils.deepClone(this[`${this.goodsTabType}Query`]); // 复制检索模型副本 避免切换分页数后数据变动
      // if (this[`${this.goodsTabType}Params`].inspectionTime) {
      //   this[`${this.goodsTabType}Params`].inspectionTime = this[`${this.goodsTabType}Params`].inspectionTime.getTime();
      // }
      // if (this[`${this.goodsTabType}Params`].refundTime) {
      //   this[`${this.goodsTabType}Params`].refundTime = this[`${this.goodsTabType}Params`].refundTime.getTime();
      // }
      this.getData();
    },
    handleShowGetGoods() {
      // this.tempGoods = [];
      this.tempGoods = utils.deepClone(this.goodsList);
      this.showGoods = true;
      this.goodsTabType = 'inspection';
      this.inspectionQuery = {};
      this.inspectionParams = {};
      this.refundQuery = {};
      this.refundParams = {};
      this.inspectionPage = {
        count: 0,
        page: 1,
        size: 10,
      };
      this.refundPage = {
        count: 0,
        page: 1,
        size: 10,
      };
      // 获取下拉菜单数据
      this.getPayableInspectionCode();
      this.getPayableRefundCode();

      // 获取实际数据
      this.getData();
    },
    // 获取验收和退货的明细
    getData(isAll) { // 是否勾选"选择搜索结果内所有明细"
      return new Promise((resolve) => {
        // console.log('this.goodsTabType:' + this.goodsTabType);
        this[`${this.goodsTabType}Params`].page = this[`${this.goodsTabType}Page`].page;
        this[`${this.goodsTabType}Params`].size = this[`${this.goodsTabType}Page`].size;
        this[`${this.goodsTabType}Params`].type = this.tabTypeMap[this.goodsTabType];
        this[`${this.goodsTabType}Params`].payableId = this.payableId;
        this[`${this.goodsTabType}Params`].financePayableCreateType = this.info.financePayable.financePayableCreateType;
        this[`${this.goodsTabType}GoodsList`] = []; // 避免重复添加数据
        let finalFn = null;
        if (this.tabTypeMap[this.goodsTabType] === 1) { // 验收
          this[`${this.goodsTabType}Params`].supplierId = this.info.financePayable.supplierId;
          finalFn = finance.getlistPayableInspectionInfos;
        } else if (this.tabTypeMap[this.goodsTabType] === 2) { // 退货
          this[`${this.goodsTabType}Params`].supplierStoreId = this.info.financePayable.supplierId;
          finalFn = finance.getlistPayableRefundInfos;
        } else {
          this[`${this.goodsTabType}Params`].supplierId = this.info.financePayable.supplierId;
          finalFn = finance.getlistPayableRecallDetail;
        }
        // 勾选了"选择搜索结果内所有明细"
        isAll && delete this[`${this.goodsTabType}Params`].page;
        isAll && delete this[`${this.goodsTabType}Params`].size;

        // 取消全局loading
        this.$store.commit('setDisableLoading', true);
        this.modalLoading = true;
        finalFn(this[`${this.goodsTabType}Params`]).then((res) => {
          if (res.data.status === 200) {
            this[`${this.goodsTabType}Page`].count = res.data.data.count;
            res.data.data.list.forEach((item) => {
              const result = item.financePayableInfo;
              result.ableToUpdateTaxRate = item.ableToUpdateTaxRate; // 1可以修改确认进项税率 2不可以修改
              if (utils.isEmpty(result.realInputTaxRate)) {
                result.realInputTaxRate = result.taxRate;
              }

              // 确认进价
              if (utils.isEmpty(result.realPriceWithTax)) {
                result.realPriceWithTax = result.priceBeforeTax;
              }

              result.realInputTaxRateStr = `${result.realInputTaxRate}%`;
              result.taxRateStr = `${result.taxRate}%`;
              // 已经选中的列表和临时选中的列表
              const isChecked = this.selectedIds.includes(result.payableInfoKey) || this.selectedTempGoodsIds.includes(result.payableInfoKey);
              result._checked = isChecked;

              result._disabled = this.selectedIds.includes(result.payableInfoKey);
              this[`${this.goodsTabType}GoodsList`].push(result);
              if (isAll && !isChecked) {
                this.tempGoods.push(result);
              }
            });
          } else {
            this.$Message.error(res.data.error);
          }
          this.modalLoading = false;
          resolve();
        }).catch((err) => {
          this.modalLoading = false;
          utils.handleError(err);
        });
      });
    },
    // 获取供应商列表
    getSuppliers() {
      return new Promise((resolve) => {
        finance.getFinancePayableSupplier().then((res) => {
          if (res.data.status === 200) {
            this.suppliers = res.data.data;
            this.info.financePayable.supplierId = res.data.data[0].supplierId;
            this.$set(this.info.financePayable, 'financePayableCreateType', this.financePayableType[0].financePayableCreateType);
            this.tempFinancePayableCreateType = this.financePayableType[0].financePayableCreateType;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    getDetails() {
      finance.getFinancePayableDetail({ financePayableId: this.payableId }).then((res) => {
        if (res.data.status === 200) {
          const temp = res.data.data;
          this.tempFinancePayableCreateType = temp.financePayable.financePayableCreateType;
          this.saveText = temp.financePayable.status === 4 ? '' : '保存';
          temp.financePayable.invoiceDate = temp.financePayable.invoiceDate || '';
          temp.financePayableInfoList.forEach((item) => {
            const confirmedTotalAmount = item.confirmedTotalAmount;
            if (item.discountWithoutTax !== 0 || item.discountTax !== 0) {
              item.realTotalPriceBeforeTax = confirmedTotalAmount;
            }
            this.goodsList.push(item);
            // this.tempGoods.push(result);
          });
          if (temp.rebateInfoList && temp.rebateInfoList.length) {
            this.showActualBatch = true;
            temp.rebateInfoList.forEach((item) => {
              const result = item;
              result.amountWithoutTaxBalance = item.submitAmount;
              this.actualBatchInfo.push(result);
            });
          }
          this.info = utils.deepClone(temp);
          this.infosArr[0] = {
            name: '门店名称:',
            value: this.info.financePayable.storeName,
          };
          this.infosArr[1] = {
            name: '供应商:',
            value: this.info.financePayable.supplierName,
          };
          this.infosArr[2] = {
            name: '创建人:',
            value: this.info.financePayable.createUserName,
          };
          this.infosArr[3] = {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(this.info.financePayable.createTime),
          };
          this.isClear = false;
          this.tempSupplier = this.info.financePayable.supplierId;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleRestQuery() {
      this[`${this.goodsTabType}Query`] = {};
    },
    getPayableInspectionCode() {
      const params = {
        supplierId: this.info.financePayable.supplierId,
        payableId: this.payableId,
      };
      finance.getPayableInspectionCode(params).then((res) => {
        if (res.data.status === 200) {
          this.inspectionCodeList = res.data.data; // 获取验收单
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getPayableRefundCode() {
      const params = {
        supplierStoreId: this.info.financePayable.supplierId,
        payableId: this.payableId,
      };
      finance.getPayableRefundCode(params).then((res) => {
        if (res.data.status === 200) {
          this.refundCodeList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleSelectAllResult(val) {
      if (val) {
        this.getData(val).then(() => {
          this.getData();
        });
      } else {
        this.tempGoods = this.tempGoods.filter(item => item.referType !== this.tabTypeMap[this.goodsTabType]);
        this.getData();
      }
    },
    diffInfo(row) {
      return (row.priceBeforeTax !== Number(row.realPriceWithTax) || (row.taxRate !== row.realInputTaxRate) || (row.discountWithoutTax && row.discountWithoutTax != 0) || (row.discountTax && row.discountTax != 0));
    },
  },
  created() {
    this.payableId = this.$route.params.id;
    if (this.payableId) {
      this.getDetails();
    } else {
      this.saveText = '保存'; // 如果直接显示"保存"按钮，在进入修改页面（审核不通过状态）的时候，需要根据状态来判断是否显示"保存"按钮，这样如果数据加载稍微慢一点，会出现"保存"按钮突然消失问题
      this.getSuppliers().then(() => {
        // this.getDetails();
      });
    }
  },
};

</script>
<style lang="less" scoped>
  .payableGoods .noEqual{
    color: #FF4D07
  }
  .blue {
    color: #1890FF;
  }
  /deep/ .ivu-card-extra {
    left: 100px;
    top: 9px;
  }
  .button-txt {
    display: block;
    color: red;
  }
  .editBatch {
    /deep/ .ivu-table-fixed-header {
       .ivu-checkbox-inner:nth-child(1){
        display: none !important;
      }
    }
    /deep/ .ivu-checkbox-inner {
      border-radius:50%;
    }
  }
</style>
